module.exports = __webpack_public_path__ + "img/4-quad.13efb134.png";